import { RightOffClear } from "../../redux/slices/offcanvas";

import { useState } from "react";

import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";

import Nav from "react-bootstrap/Nav";

import Tab from "react-bootstrap/Tab";
import { styled } from "@mui/material/styles";
import { AttachmentFiles, ClearImages } from "../../redux/slices/attachments";
import { Button, CircularProgress, IconButton, TextField } from "@mui/material";
import { CloudUpload as CloudUploadIcon, Delete } from "@mui/icons-material";
import {
  AgentResponce,
  AgentGetResponce,
} from "../../redux/slices/agentresponce";
import {
  AgentResponceDeposits,
  AgentGetResponceDeposits,
} from "../../redux/slices/depositsresponce";
import { sendCashout } from "../../lib/socket";

function GetUserDatas() {
  const datas = useSelector((v) => v.rtl);
  const pictures = useSelector((v) => v.files);
  const sections = useSelector((v) => v?.agent);
  const keys = useSelector((v) => v?.key?.key);
  const dispatch = useDispatch();

  const copyToClipboard = (text, field) => {
    if (text) {
      navigator.clipboard.writeText(text).then(() => {
        toast.success(`Copied text : ${text}`);
      });
    }
  };

  return (
    <Tab.Container defaultActiveKey={keys}>
      <div className="flex justify-between gap-2 p-6 min-h-screen bg-white">
        <div className="flex  flex-col items-center border-r-2 border-gray-200 pr-3 col-4 ">
          <button
            onClick={() => dispatch(RightOffClear())}
            className="absolute top-4 right-4 text-gray-600 text-xl"
          >
            ✖
          </button>
          <h2 className="text-xl font-semibold">Customer Profile</h2>

          <div className="relative mt-4">
            <div className="w-24 h-24 rounded-full border-4 border-purple-500 overflow-hidden">
              <img
                src={
                  datas?.data?.user?.picture
                    ? datas?.data?.user?.picture
                    : "/images/user.png"
                }
                alt="Profile"
                className="w-full h-full object-cover"
              />
            </div>
          </div>
          <h3 className="text-lg font-semibold mt-3">
            {datas?.data?.user?.name && datas?.data?.user?.name}
          </h3>
          <p className="text-gray-500 mb-2">
            {datas?.data?.user?.role && datas?.data?.user?.role}
          </p>
          {/* {datas?.row?.action === "radeem" ? (
            <div className="flex justify-between items-center gap-2">
              <Nav.Link
                eventKey="approve"
                className="bg-green-600 py-2 px-4 rounded-md text-white"
              >
                Pay ${datas?.row?.amount && datas?.row?.amount}
              </Nav.Link>

              <Nav.Link
                eventKey="rejected"
                className="bg-red-600 py-2 px-4 rounded-md text-white"
              >
                Reject
              </Nav.Link>
            </div>
          ) : (
            <div className="flex justify-between items-center gap-2">
              <Nav.Link
                eventKey="approve"
                className="bg-green-600 py-2 px-4 rounded-md text-white"
              >
                Approved
              </Nav.Link>

              <Nav.Link
                eventKey="rejected"
                className="bg-red-600 py-2 px-4 rounded-md text-white"
              >
                Reject
              </Nav.Link>
            </div>
          )} */}
          <div className="w-full mt-6 max-w-md">
            {datas?.row?.action === "radeem" ? (
              <div className="mb-3 flex items-start gap-3 p-2 text-left flex-col bg-gray-100 rounded-lg">
                <p className="font-semibold mb-2">Customer Bank details</p>
                <p className="text-lg text-gray-500">
                  Bank:
                  <span
                    className="capitalize"
                    onClick={() => copyToClipboard(datas?.row?.cam, "method")}
                  >
                    {datas?.row?.cam && datas?.row?.cam}
                  </span>
                </p>
                <p
                  className="text-lg text-gray-500 cursor-pointer"
                  onClick={() => copyToClipboard(datas?.row?.cad, "id")}
                >
                  <span className="capitalize">
                    {datas?.row?.cam && datas?.row?.cam} ID:
                  </span>
                  {datas?.row?.cad && datas?.row?.cad}
                </p>
                <p className="text-lg text-gray-500">
                  Cashout Amount: ${datas?.row?.amount && datas?.row?.amount}
                </p>
                <p className="text-lg text-gray-500">
                  Remmaing Bal: ${datas?.row?.balance && datas?.row?.balance}
                </p>
                <p className="text-lg text-gray-500">
                  Payment status:
                  {datas?.row?.status && datas?.row?.status}
                </p>
              </div>
            ) : (
              <div className="mb-3 flex items-start gap-3 p-2 text-left flex-col bg-gray-100 rounded-lg">
                <p className="font-semibold mb-2">Customer Details</p>
                <p className="text-lg text-gray-500">
                  Payment Method:
                  <span
                    className="capitalize"
                    onClick={() => copyToClipboard(datas?.row?.cam, "method")}
                  >
                    {datas?.row?.cam && datas?.row?.cam}
                  </span>
                </p>
                <p
                  className="text-lg text-gray-500 cursor-pointer"
                  onClick={() =>
                    copyToClipboard(datas?.row?.depositid?.value, "id")
                  }
                >
                  <span className="">
                    ID:
                    {datas?.row?.depositid?.value &&
                      datas?.row?.depositid?.value}{" "}
                  </span>
                  {datas?.row?.cad && datas?.row?.cad}
                </p>
                <p className="text-lg text-gray-500">
                  Amount: ${datas?.row?.amount && datas?.row?.amount}
                </p>

                <p className="text-lg text-gray-500 capitalize">
                  Status: {datas?.row?.status && datas?.row?.status}
                </p>
              </div>
            )}
          </div>
        </div>

        <div className="text-left w-full">
          <Tab.Content>
            <Tab.Pane eventKey="approve">
              {sections?.loading ? (
                <div className="spinner-border text-light" role="status">
                  <span className="visually-hidden">Loading...</span>
                </div>
              ) : (
                <InputFileUpload />
              )}
            </Tab.Pane>
            <Tab.Pane eventKey="rejected">
              {sections?.loading ? (
                <div className="spinner-border text-light" role="status">
                  <span className="visually-hidden">Loading...</span>
                </div>
              ) : (
                <RejectedFileUpload />
              )}
            </Tab.Pane>
          </Tab.Content>
        </div>
      </div>
    </Tab.Container>
  );
}

export function InputFileUpload() {
  const dispatch = useDispatch();
  const uploadedFiles = useSelector((state) => state?.files);

  const processing = useSelector((state) => state?.agent);
  const datas = useSelector((v) => v.rtl);
  const [transactionIds, setTransactionIds] = useState([]);
  const data = useSelector((state) => state?.login);

  const handleTransactionIdChange = (index, event, trans) => {
    const updatedTransactionIds = [...transactionIds];
    updatedTransactionIds[index] = event.target.value;
    setTransactionIds(updatedTransactionIds);
  };

  const handleSubmit = async () => {
    if (datas?.row?.action === "radeem") {
      const fileExists = uploadedFiles?.data.some((item) => !item.uploader);
      if (!fileExists) {
        toast.info("You must upload a file");
        return;
      }
      const result =
        uploadedFiles?.data?.length > 0 &&
        uploadedFiles?.data?.map((file, index) => {
          return {
            image: file?.image,
            transactionId: file?.transactionId
              ? file?.transactionId
              : transactionIds[index],
            uploader: file.uploader ? file.uploader : "Agent",
          };
        });

      const payload = {
        uid: datas?.data?.user?._id,
        id: datas?.row?._id,
        aid: data?.user?.id,
        aname: data?.user?.name,
        status: "paid",
        attach: !result ? [] : result,
      };
      const userid = datas?.data?.user?._id;

      dispatch(AgentResponce(payload));
      await sendCashout("admin-cashout", userid, "admin-456", "private-cash");
    } else {
      const result =
        uploadedFiles?.data?.length > 0 &&
        uploadedFiles?.data?.map((file, index) => {
          return {
            image: file?.image,
            uploader: file.uploader ? file.uploader : "Agent",
          };
        });

      const payload = {
        uid: datas?.data?.user?._id,
        id: datas?.row?._id,
        aid: data?.user?.id,
        aname: data?.user?.name,
        amount: datas?.row?.amount,
        attach: !result ? [] : result,
        status: "deposit",
      };
      dispatch(AgentResponceDeposits(payload));
    }
  };

  const handleFileUpload = (event) => {
    const files = event.target.files;
    if (!files || files.length === 0) return;

    dispatch(AttachmentFiles(files, uploadedFiles?.data));
    // dispatch(ClearImages());
  };

  return (
    <>
      <div className="p-4">
        <div
          style={{
            display: "grid",
            gridTemplateColumns: "repeat(5, 1fr)",
            gap: "16px",
            marginBottom: "10px",
          }}
        >
          {datas?.row?.status === "rejected" ? (
            <div
              style={{
                width: "100%",
                height: "100%",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                backgroundColor: "#f0f0f0",
                borderRadius: "5px",
              }}
            >
              <Button
                component="label"
                variant="contained"
                disabled={uploadedFiles?.loading}
                className="mb-4 h-full w-full text-center flex flex-col justify-center items-center "
              >
                {uploadedFiles?.loading ? (
                  <>
                    <div className="spinner-border " role="status">
                      <span className="visually-hidden">Loading...</span>
                    </div>
                    Please wait ..
                  </>
                ) : (
                  <>
                    <CloudUploadIcon fontSize="large" />
                    Upload screenshot
                    <input
                      type="file"
                      multiple
                      onChange={handleFileUpload}
                      hidden
                    />
                  </>
                )}
              </Button>
            </div>
          ) : datas?.row?.status === "pending" ? (
            <div
              style={{
                width: "100%",
                height: "100%",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                backgroundColor: "#f0f0f0",
                borderRadius: "5px",
              }}
            >
              <Button
                component="label"
                variant="contained"
                disabled={uploadedFiles?.loading}
                className="mb-4 h-full w-full text-center flex flex-col justify-center items-center "
              >
                {uploadedFiles?.loading ? (
                  <>
                    <div className="spinner-border " role="status">
                      <span className="visually-hidden">Loading...</span>
                    </div>
                    Please wait ..
                  </>
                ) : (
                  <>
                    <CloudUploadIcon fontSize="large" />
                    Upload screenshot
                    <input
                      type="file"
                      multiple
                      onChange={handleFileUpload}
                      hidden
                    />
                  </>
                )}
              </Button>
            </div>
          ) : (
            ""
          )}

          {datas?.row?.action === "radeem" ? (
            uploadedFiles?.data?.length > 0 &&
            uploadedFiles?.data?.map((file, index) => {
              return (
                <div
                  key={index}
                  style={{
                    width: "100%",
                    height: "auto",
                    position: "relative",
                  }}
                >
                  {file?.transactionId ? (
                    <div className="mb-1">
                      <TextField
                        fullWidth
                        className="bg-gray-200 text-black"
                        disabled={file?.uploaded}
                        variant="outlined"
                        value={file?.transactionId}
                      />{" "}
                    </div>
                  ) : (
                    <div className="mb-1">
                      <TextField
                        fullWidth
                        variant="outlined"
                        disabled={file?.uploaded ? file?.uploaded : false}
                        label={`Transaction ID ${index + 1}`}
                        value={transactionIds[index]}
                        onChange={(event) =>
                          handleTransactionIdChange(index, event)
                        }
                      />
                    </div>
                  )}
                  <div className="relative">
                    <img
                      src={file?.image}
                      alt={`upload-preview-${index}`}
                      width="100%"
                      height="100%"
                      style={{ borderRadius: "5px", objectFit: "cover" }}
                    />
                  </div>
                </div>
              );
            })
          ) : (
            <>
              <div
                style={{
                  width: "100%",
                  height: "auto",
                  position: "relative",
                }}
              >
                {uploadedFiles?.data?.length > 0 &&
                  uploadedFiles?.data?.map((file, index) => {
                    return (
                      <div key={index} className="relative">
                        <img
                          src={file?.image}
                          alt={`upload-preview-${index}`}
                          width="100%"
                          height="100%"
                          style={{ borderRadius: "5px", objectFit: "cover" }}
                        />
                      </div>
                    );
                  })}
              </div>
            </>
          )}
        </div>

        {datas?.row?.status === "rejected" ? (
          <Button
            variant="contained"
            onClick={handleSubmit}
            style={{ marginTop: "20px" }}
          >
            Submit
          </Button>
        ) : datas?.row?.status === "pending" ? (
          <Button
            variant="contained"
            onClick={handleSubmit}
            style={{ marginTop: "20px" }}
          >
            Submit
          </Button>
        ) : (
          ""
        )}
      </div>
    </>
  );
}

export function RejectedFileUpload() {
  const dispatch = useDispatch();
  const uploadedFiles = useSelector((state) => state?.files);

  const [transactionIds, setTransactionIds] = useState([]);

  const processing = useSelector((state) => state?.agent);
  const datas = useSelector((v) => v.rtl);
  const [remarks, setremarks] = useState("");
  const data = useSelector((state) => state?.login);
  const handleSubmit = async () => {
    // if (!uploadedFiles?.data?.length) {
    //   return toast.error("Please upload screenshort!");
    // }
    if (!remarks) {
      toast.info("You must give remarks");
      return;
    }
    if (datas?.row?.action === "radeem") {
      const result =
        uploadedFiles?.data?.length > 0 &&
        uploadedFiles?.data?.map((file, index) => {
          return {
            image: file?.image,
            transactionId: file?.transactionId && file?.transactionId,
            uploader: file.uploader ? file.uploader : "Agent",
          };
        });

      const payload = {
        uid: datas?.data?.user?._id,
        id: datas?.row?._id,
        aid: data?.user?.id,
        aname: data?.user?.name,
        remarks: remarks,
        status: "rejected",
        attach: !result ? [] : result,
      };
      dispatch(AgentGetResponce(payload));
      const userid = datas?.data?.user?._id;
      await sendCashout("admin-cashout", userid, "admin-456", "private-cash");
    } else {
      const result =
        uploadedFiles?.data?.length > 0 &&
        uploadedFiles?.data?.map((file, index) => {
          return {
            image: file?.image,
            uploader: file.uploader ? file.uploader : "Agent",
          };
        });
      const payload = {
        uid: datas?.data?.user?._id,
        id: datas?.row?._id,
        aid: data?.user?.id,
        aname: data?.user?.name,
        remarks: remarks,
        attach: !result ? [] : result,
      };

      dispatch(AgentGetResponceDeposits(payload));
    }
  };

  const handleFileUpload = (event) => {
    const files = event.target.files;
    if (!files || files.length === 0) return;

    dispatch(AttachmentFiles(files, uploadedFiles?.data));
    // dispatch(ClearImages());
  };

  return (
    <>
      <div className="p-4">
        <h2 className="text-xl font-semibold mb-4">Reasons</h2>
        {datas?.row?.status === "rejected" ? (
          ""
        ) : datas?.row?.status === "pending" ? (
          <div className="mb-4 flex items-center">
            {/* <span className="w-32 font-medium">Attachment:</span>
      <input type="file" className="border p-2 rounded-lg" /> */}
            <Button
              component="label"
              variant="contained"
              disabled={uploadedFiles?.loading}
              className="mb-4 h-full w-auto text-center flex flex-col justify-center items-center"
            >
              {uploadedFiles?.loading ? (
                <>
                  <div className="spinner-border " role="status">
                    <span className="visually-hidden">Loading...</span>
                  </div>
                  Please wait ..
                </>
              ) : (
                <>
                  <CloudUploadIcon fontSize="large" />
                  Upload screenshot
                  <input
                    type="file"
                    multiple
                    onChange={handleFileUpload}
                    hidden
                  />
                </>
              )}
            </Button>
          </div>
        ) : (
          ""
        )}

        <div
          style={{
            display: "grid",
            gridTemplateColumns: "repeat(5, 1fr)",
            gap: "16px",
            marginBottom: "10px",
          }}
        >
          {datas?.row?.action === "radeem" ? (
            uploadedFiles?.data?.length > 0 &&
            uploadedFiles?.data?.map((file, index) => {
              if (file?.image) {
                return (
                  <div
                    key={index}
                    style={{
                      width: "100%",
                      height: "auto",
                      position: "relative",
                    }}
                  >
                    <div className="relative">
                      <img
                        src={file?.image}
                        alt={`upload-preview-${index}`}
                        width="100%"
                        height="100%"
                        style={{ borderRadius: "5px", objectFit: "cover" }}
                      />
                    </div>
                  </div>
                );
              }
            })
          ) : (
            <>
              {uploadedFiles?.data?.length > 0 &&
                uploadedFiles?.data?.map((file, index) => {
                  if (file?.image) {
                    return (
                      <div
                        key={index}
                        style={{
                          width: "100%",
                          height: "auto",
                          position: "relative",
                        }}
                      >
                        <div className="relative">
                          <img
                            src={file?.image}
                            alt={`upload-preview-${index}`}
                            width="100%"
                            height="100%"
                            style={{
                              borderRadius: "5px",
                              objectFit: "cover",
                            }}
                          />
                        </div>
                      </div>
                    );
                  }
                })}
            </>
          )}
        </div>
        <div className="mb-4">
          <label className="block font-medium mb-1">Remarks:</label>
          <div className="mb-2">
            {datas?.row?.remarks &&
              datas?.row?.remarks?.map((val) => <span>Agent: {val}</span>)}
          </div>
          {datas?.row?.status == "pending" && (
            <textarea
              type="text"
              className="w-full border min-h-40 p-2 rounded-lg"
              placeholder="Enter remarks..."
              onChange={(e) => setremarks(e.target.value)}
            />
          )}
        </div>

        {datas?.row?.status === "rejected" ? (
          ""
        ) : datas?.row?.status === "pending" ? (
          <button
            onClick={handleSubmit}
            className="bg-blue-600 text-white px-4 py-2 rounded-lg hover:bg-blue-700"
          >
            Submit
          </button>
        ) : (
          ""
        )}
      </div>
    </>
  );
}

export default GetUserDatas;
